import Axios from 'axios';
import {networkConfig} from '../config/network';

export type LoadingStatus = "idle" | "loading" | "error";

export async function fetchEdstartData<T>(path: string) {
    return  Axios.get<T>(`${networkConfig.adminServerUrl}/api/external/front${path}`);
}

